import { render, staticRenderFns } from "./disciplines.vue?vue&type=template&id=6a4f8982&scoped=true"
import script from "./disciplines.vue?vue&type=script&lang=js"
export * from "./disciplines.vue?vue&type=script&lang=js"
import style0 from "./disciplines.vue?vue&type=style&index=0&id=6a4f8982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4f8982",
  null
  
)

export default component.exports